import React, { useEffect, useState } from "react";

import { AlertType } from "@constants";
import { Alert, Loader } from "@partials";
import { errorLogger, getLocalization } from "@utilities";

import { CalculatorWidget as Props } from "./types";

const Calculator: React.FC<Props> = ({ timeout, scriptUrl, localization }) => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [hasError, setHasError] = useState<boolean>(false);

  const script = document.createElement("script");

  const showCaclulator = isLoaded && !hasError;
  const showLoader = !isLoaded && !hasError;

  const fetchCalculatorWidget = async () => {
    try {
      await fetch(scriptUrl).then((response) => {
        if (response.ok) {
          setTimeout(() => {
            script.src = response.url;
            document.body.appendChild(script);

            setIsLoaded(true);
          }, timeout * 1000);
        } else if (response.status >= 404) {
          setHasError(true);
        }
      });
    } catch (error) {
      if (!isProduction) {
        errorLogger(error);
      }
      setHasError(true);
    }
  };

  useEffect(() => {
    fetchCalculatorWidget();
  }, []);

  return (
    <div className="container">
      <div className="row">
        <div className="h-16 sm:col-22 sm:offset-1">
          {showLoader && <Loader />}
          {hasError && (
            <Alert
              type={AlertType.Error}
              text={getLocalization(localization, "ErrorMessage")}
              textAttributes={{ role: "alert", "aria-live": "assertive" }}
            />
          )}
          {showCaclulator && <>kalkukacka</>}
        </div>
      </div>
    </div>
  );
};

export default Calculator;
